import { FC, PropsWithChildren } from "react";
import { Paper } from "@mui/material";

interface IPaperWrapperProps {
  wrapInPaper: boolean;
}

const PaperWrapper: FC<PropsWithChildren<IPaperWrapperProps>> = ({
  wrapInPaper,
  children,
}) =>
  wrapInPaper ? (
    <Paper
      sx={{
        padding: "2rem",
      }}
    >
      {children}
    </Paper>
  ) : (
    children
  );

export default PaperWrapper;
